import { render, staticRenderFns } from "./BillingChangesList.vue?vue&type=template&id=60d1f636&scoped=true"
import script from "./BillingChangesList.vue?vue&type=script&lang=js"
export * from "./BillingChangesList.vue?vue&type=script&lang=js"
import style0 from "./BillingChangesList.vue?vue&type=style&index=0&id=60d1f636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1f636",
  null
  
)

export default component.exports